export const convertToSlug = (text) => {
  const from =
    "ÁÀÃẠÂẤẦẪẬĂẮẰẴẶÉÈẼẸÊẾỀỄỆÍÌĨỊÓÒÕỌÔỐỒỖỘƠỚỜỠỢÚÙŨỤƯỨỪỮỰÝỲỸỴĐ" +
    "áàãạâấầẫậăắằẵặéèẽẹêếềễệíìĩịóòõọôốồỗộơớờỡợúùũụưứừữựýỳỹỵđ";
  const to =
    "AAAAAAAAAAAAAAAAAEEEEEEEEIIIIOOOOOOOOOOOOOUUUUUUUUUYYYYD" +
    "aaaaaaaaaaaaaaaaaeeeeeeeeiiiioooooooooooooouuuuuuuuuyyyyd";

  // Thay thế ký tự
  const slug = text
    .split("")
    .map((char) => {
      const index = from.indexOf(char);
      return index !== -1 ? to[index] : char;
    })
    .join("")
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");

  return slug;
}
